import Logger from "../Logger";
import BaseObject from "../models/BaseObject";

const logger = new Logger();

export class OnboadingData {
  content: any;

  // returning false avoid closing Window

  onOk: (() => boolean) | undefined;
  onAbort: (() => boolean) | undefined;
}

export default class OnboadingManager extends BaseObject {
  public get className(): string {
    return "OnboadingManager"; // no itx
  }

  currentWindow: any | undefined = undefined;
  isOpen = false;

  onClose: (() => boolean) | undefined;

  closeWindow() {
    if (this.onClose) {
      this.onClose();
    }

    this.onClose = undefined;

    this.isOpen = false;
    this.currentWindow = undefined;
    this.raiseOnChange();
  }

  private openWindow(window: any) {
    this.currentWindow = window;
    this.isOpen = true;
    this.raiseOnChange();
  }
  openWindowWithKey(key: string, window: any) {
    // function checkIfAllreadySeenOrNotAnymoreShow() {
    //   let res = false;
    //   if (state.opendOnboardingKeys.has(key)) {
    //     res = true;
    //     logger.log("key allready shown(state): " + key);
    //   } else {
    //     state.onBoardingSeenKeys?.forEach((value) => {
    //       if (value == key) {
    //         res = true;
    //         logger.log("key allready shown(local): " + key);
    //       }
    //     });
    //   }
    //   return res;
    // }
    // if (!checkIfAllreadySeenOrNotAnymoreShow()) {
    //   state.opendOnboardingKeys.add(key);
    //   this.openWindow(window);
    // }
  }

  clear() {
    this.closeWindow();
  }
}
